import { MSG, wa } from "../../data/site";
import { WhatsAppIcon } from "./Icons";

export const FloatingWhatsApp = () => (
    <a
        href={wa(MSG.consulta)}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Conversar pelo WhatsApp"
        data-testid="floating-whatsapp-button"
        className="group fixed bottom-5 right-5 z-40 flex items-center gap-3"
    >
        <span className="pointer-events-none hidden translate-x-2 rounded-full border border-slate-200 bg-white px-4 py-2 text-xs font-semibold text-slate-700 opacity-0 shadow-lg transition-all duration-300 group-hover:translate-x-0 group-hover:opacity-100 sm:block">
            Agendar pelo WhatsApp
        </span>
        <span className="animate-wa-pulse flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-xl shadow-emerald-600/30 transition-transform duration-300 group-hover:scale-105">
            <WhatsAppIcon className="h-7 w-7" />
        </span>
    </a>
);
